import { useForm } from '@/libs/antd/form';
import { LoadingOutlined } from '@ant-design/icons';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import {
	getNAPEDDPEPAnalysis,
	NAPEDDPEPAnalysis,
	NAPState,
	verifyNAPEDDPEPAnalysis,
} from '@/libs/fleet-api/services/nap';
import { Button } from 'antd';
import { useMutation, useQuery } from '@tanstack/react-query';
import { FC, Fragment } from 'react';
import { Form } from 'antd';
import rule from '@/libs/antd/rules';
import TextArea from 'antd/es/input/TextArea';

const NAPSummaryConsent: FC<{
	napState?: NAPState;
	napId?: number;
	prospectId: string;
	onSubmitted: () => void;
}> = ({ napId, napState, prospectId, onSubmitted }) => {
	// Preparations
	const { form, fieldName } = useForm<NAPEDDPEPAnalysis>();
	const isReadOnly =
		napState?.action === 'VIEW' || napState?.action === 'DISABLED';

	// Fetch Detail Data
	const getNAPEDDPEPAnalysisQuery = useQuery({
		queryKey: ['nap-edd-pep-analysis', prospectId],
		queryFn: () => getNAPEDDPEPAnalysis(prospectId),
	});
	const { data } = getNAPEDDPEPAnalysisQuery.data ?? {};
	console.log(data);

	const verifyNAPEDDPEPAnalysisMutation = useMutation({
		mutationFn: verifyNAPEDDPEPAnalysis,
	});

	if (getNAPEDDPEPAnalysisQuery.isFetching) {
		return (
			<LoadingOutlined
				style={{
					marginTop: 160,
					fontSize: 100,
					color: '#1557BC',
					display: 'block',
				}}
			/>
		);
	}

	return (
		<Fragment>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{
					span: 5,
				}}
				wrapperCol={{
					span: 19,
				}}
				onFinish={async (values) => {
					await verifyNAPEDDPEPAnalysisMutation.mutateAsync(values);
					onSubmitted();
				}}
			>
				<Form.Item
					name={fieldName('id')}
					initialValue={data?.id}
					noStyle
				/>
				<Form.Item
					name={fieldName('napId')}
					initialValue={napId}
					noStyle
				/>
				<Form.Item
					name={fieldName('analysisResult')}
					initialValue={data?.analysisResult}
					label="Hasil Analisa EDD & PEP"
					rules={[rule.required()]}
				>
					<TextArea
						rows={3}
						disabled={isReadOnly}
					/>
				</Form.Item>

				<Button
					type="primary"
					htmlType="submit"
					style={{
						width: 200,
						display: 'block',
						marginLeft: 'auto',
						marginTop: 40,
					}}
					disabled={verifyNAPEDDPEPAnalysisMutation.isPending || isReadOnly}
				>
					NEXT
				</Button>
			</Form>
		</Fragment>
	);
};

export default NAPSummaryConsent;
